import { heroAssets } from '@/mocks/hero';

/* atticForeground: the transparent attic-window image is the ONLY layer that scales. */
export default function AtticScene() {
  return (
    <div className="wp-stage absolute inset-0 z-10 will-change-transform" style={{ transformOrigin: '50% 39%' }}>
      <div className="wp-window-group absolute inset-0">
        <img
          src={heroAssets.atticForeground}
          alt="Dark attic interior with a timber roof window"
          title="Attic roof window installation"
          className="h-full w-full object-cover object-center select-none"
          draggable={false}
          fetchPriority="high"
        />
      </div>
    </div>
  );
}